import type { LucideIcon } from 'lucide-react'
import { Building2, GraduationCap } from 'lucide-react'

export interface AppRegistryEntry {
  id: string
  name: string
  description: string
  /** Base path e.g. `/mykoob-admin` */
  path: string
  icon: LucideIcon
}

export const APP_REGISTRY: AppRegistryEntry[] = [
  {
    id: 'mykoob-admin',
    name: 'Mykoob Admin',
    description: 'User management, assessments, grade scales, and legal document mockups.',
    path: '/mykoob-admin',
    icon: Building2,
  },
  {
    id: 'ekool-teacher',
    name: 'eKool Teacher',
    description:
      'Subject teacher home: schedule, journals, upcoming events, and whiteboard mockups.',
    path: '/ekool-teacher',
    icon: GraduationCap,
  },
]
